/* DelaFuente — Pet Portrait Pendant.
 * Renders the "Your dog's portrait" experience on products tagged 'pet-pendant':
 * upload photo -> pick line style -> generate via the DelaFuente Worker (Gemini) ->
 * clean/center in-browser (binarize + despeckle + center) -> review/compare/delete ->
 * confirm. Injects line-item properties (style) + the ORIGINAL photo file + the approved
 * portrait preview into the /cart/add form, and gates add-to-cart until a portrait is confirmed.
 * Vanilla, no deps. Inherits Heritage design tokens. Coexists with the ring-size / letter gates.
 */
(function () {
  var cfgEl = document.getElementById('dlf-pp-config');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var WORKER = CFG.workerUrl;
  var STYLE_PROP = CFG.styleProp || 'Portrait style';
  var PHOTO_PROP = CFG.photoProp || '_Dog photo';
  var PREVIEW_PROP = CFG.previewProp || '_Portrait preview';
  var REQUIRED = CFG.required !== false;
  var ES = String(CFG.lang || '').slice(0, 2).toLowerCase() === 'es';

  var L = ES ? {
    fine: 'Línea fina', bold: 'Tinta marcada', etch: 'Grabado suave', shadow: 'Silueta',
    upTo: function (n) { return 'Hasta ' + n + ' retratos por hora'; },
    left: function (l, n) { return l + ' de ' + n + ' disponibles esta hora'; },
    limitErr: "Son 4 retratos esta hora 🌱 Limitamos las generaciones con IA para cuidar su consumo de energía y el planeta — vuelve en un ratito, por favor.",
    busy: 'Nuestro estudio está ocupado un momento.',
    notPet: "No encontramos un perro o gato en esa foto 🐾 Sube una foto clara de tu mascota, por favor.",
    unsafe: "Esa imagen no se puede usar aquí — sube una foto clara de tu mascota 🐾.",
    modalEye: 'TU RETRATO', modalCap: 'Este es el line art exacto que grabamos — tómate tu tiempo.', close: 'Cerrar',
    tryAgain: 'Intentar de nuevo', uploading: 'Subiendo foto…', useDifferent: 'Usar otra foto',
    chooseStyle: 'Ahora elige tu estilo de línea',
    chooseSub: "Ejemplos de cada estilo — dibujamos a tu mascota en el que elijas.",
    vectorizing: 'VECTORIZANDO', preview: 'VISTA PREVIA', styleWord: 'ESTILO',
    secs: 'Esto normalmente toma de 10 a 30 segundos.', cancel: 'Cancelar',
    confirmed: 'Retrato confirmado ✓', view: 'Ver', change: 'Cambiar',
    compare: 'COMPARAR FOTOS', remove: 'Quitar', useThis: 'Usar este retrato',
    upload: "Sube la foto de tu mascota", heading: "El retrato de tu mascota",
    phrases: [
      "Trazando al amigo que nunca se aparta de tu lado…",
      "Todo buen compañero merece llevarse cerca.",
      "Un rostro leal, capturado línea por línea.",
      "Algunos lazos merecen grabarse para siempre.",
      "Tu mejor amigo, pronto fundido en oro."
    ]
  } : {
    fine: 'Fine line', bold: 'Bold ink', etch: 'Soft etch', shadow: 'Silhouette',
    upTo: function (n) { return 'Up to ' + n + ' portraits per hour'; },
    left: function (l, n) { return l + ' of ' + n + ' left this hour'; },
    limitErr: "That's 4 portraits this hour 🌱 We limit AI generations to keep their energy use gentle on the planet — please come back in a little while.",
    busy: 'Our studio is busy for a moment.',
    notPet: "We couldn't spot a dog or cat in that photo 🐾 Please upload a clear photo of your pet.",
    unsafe: "That image can't be used here — please upload a clear photo of your pet 🐾.",
    modalEye: 'YOUR PORTRAIT', modalCap: 'This is the exact line art we engrave — take your time.', close: 'Close',
    tryAgain: 'Try again', uploading: 'Uploading photo…', useDifferent: 'Use a different photo',
    chooseStyle: 'Now choose your line style',
    chooseSub: "Examples of each style — we'll draw your pet in the one you pick.",
    vectorizing: 'VECTORIZING', preview: 'PREVIEW', styleWord: 'STYLE',
    secs: 'This usually takes 10–30 seconds.', cancel: 'Cancel',
    confirmed: 'Portrait confirmed ✓', view: 'View', change: 'Change',
    compare: 'COMPARE PHOTOS', remove: 'Remove', useThis: 'Use this portrait',
    upload: "Upload your pet's photo", heading: "Your pet's portrait",
    phrases: [
      "Tracing the friend who never leaves your side…",
      "Every good boy deserves to be worn close.",
      "A loyal face, captured line by line.",
      "Some bonds are worth engraving forever.",
      "Your best friend, soon cast in gold."
    ]
  };

  var TRACES = [
    { id: 'fine',   label: L.fine,   filter: 'grayscale(1) contrast(1.7) brightness(1.05)' },
    { id: 'bold',   label: L.bold,   filter: 'grayscale(1) contrast(2.6) brightness(1.08)' },
    { id: 'etch',   label: L.etch,   filter: 'grayscale(1) contrast(1.35) brightness(1.12) sepia(.12)' },
    { id: 'shadow', label: L.shadow, filter: 'grayscale(1) contrast(7) brightness(.85)' }
  ];
  var PHRASES = L.phrases;
  function traceLabel(id) { for (var i = 0; i < TRACES.length; i++) if (TRACES[i].id === id) return TRACES[i].label; return L.bold; }

  var S = { photos: [], sel: 0, uploading: false, awaitingStyle: false, processing: false,
    trace: null, error: null, pendingFile: null, pendingUrl: null, pendingB64: null, pendingMime: null,
    phraseIdx: 0, viewing: false };
  var phraseTimer = null, genAbort = null, genCancelled = false, root = null;
  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  function form() { return document.querySelector('form[action*="/cart/add"]'); }
  function mainBtn() { var f = form(); return f && f.querySelector('button[type="submit"]'); }

  /* ---------- cart form: properties + files + gating ---------- */
  function setTextProp(name, val) {
    var f = form(); if (!f) return;
    var el = f.querySelector('input[data-pp-text="' + name + '"]');
    if (val == null) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-pp-text', name); el.name = 'properties[' + name + ']'; f.appendChild(el); }
    el.value = val;
  }
  function setFileProp(name, file) {
    var f = form(); if (!f) return;
    var el = f.querySelector('input[data-pp-file="' + name + '"]');
    if (!file) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('input'); el.type = 'file'; el.setAttribute('data-pp-file', name); el.name = 'properties[' + name + ']'; el.style.display = 'none'; f.appendChild(el); }
    try { var dt = new DataTransfer(); dt.items.add(file); el.files = dt.files; } catch (e) {}
  }
  function attachSelection() {
    var ph = S.photos[S.sel]; if (!ph) return;
    setTextProp(STYLE_PROP, traceLabel(ph.style));
    setFileProp(PHOTO_PROP, ph.file);
    if (ph.previewFile) setFileProp(PREVIEW_PROP, ph.previewFile);
  }
  function clearSelection() { setTextProp(STYLE_PROP, null); setFileProp(PHOTO_PROP, null); setFileProp(PREVIEW_PROP, null); }
  function confirmed() { var ph = S.photos[S.sel]; return !!(ph && ph.confirmed); }
  function refreshGate() {
    var btn = mainBtn(); if (!btn) return;
    if (REQUIRED && !confirmed()) { btn.setAttribute('data-pet-required', ''); btn.disabled = true; }
    else {
      btn.removeAttribute('data-pet-required');
      if (!btn.hasAttribute('data-size-required') && !btn.hasAttribute('data-letter-required') && !btn.hasAttribute('data-oos')) btn.disabled = false;
    }
  }

  /* ---------- upload + generation ---------- */
  function onFile(f) {
    if (!f || !/^image\//.test(f.type)) return;
    S.pendingFile = f; S.pendingMime = f.type; S.error = null;
    var rd = new FileReader();
    rd.onload = function () {
      S.pendingUrl = rd.result; S.pendingB64 = rd.result.split(',')[1];
      S.uploading = true; render();
      setTimeout(finishUpload, 1400);
    };
    rd.readAsDataURL(f);
  }
  function finishUpload() { S.uploading = false; S.awaitingStyle = true; render(); }
  function chooseTrace(id) { S.awaitingStyle = false; startGenerate(id); }
  function backFromStyle() { S.awaitingStyle = false; S.pendingFile = S.pendingUrl = S.pendingB64 = S.pendingMime = null; S.error = null; render(); }
  function delPhoto(i) {
    S.photos.splice(i, 1);
    if (!S.photos.length) { S.sel = 0; S.trace = null; S.error = null; }
    else { if (S.sel > i) S.sel--; if (S.sel >= S.photos.length) S.sel = S.photos.length - 1; }
    clearSelection(); refreshGate(); render();
  }
  function cancelGeneration() {
    genCancelled = true; if (genAbort) { try { genAbort.abort(); } catch (e) {} }
    clearInterval(phraseTimer); S.processing = false; S.awaitingStyle = true; S.error = null; render();
  }

  var GEN_LIMIT = 4, GEN_WINDOW = 3600000; // máx 4 generaciones por hora, por navegador
  function genRecent() { var now = Date.now(), log; try { log = JSON.parse(localStorage.getItem('dlf_pp_gen') || '[]'); } catch (e) { log = []; } return log.filter(function (t) { return now - t < GEN_WINDOW; }); }
  function genRecord() { var r = genRecent(); r.push(Date.now()); try { localStorage.setItem('dlf_pp_gen', JSON.stringify(r)); } catch (e) {} }
  function limitNote() { var left = Math.max(0, GEN_LIMIT - genRecent().length); var t = left === GEN_LIMIT ? L.upTo(GEN_LIMIT) : L.left(left, GEN_LIMIT); return '<div class="dlf-pp__limit">' + t + ' 🌱</div>'; }

  async function startGenerate(styleId) {
    S.trace = styleId;
    if (genRecent().length >= GEN_LIMIT) {
      S.processing = false; S.awaitingStyle = false;
      S.error = L.limitErr;
      render(); return;
    }
    // NB: the generation is recorded against the hourly limit only when the Worker actually
    // produces a result (success) or the model rejects the image (not_pet/unsafe) — NOT on a
    // cancel or a network/worker outage, so an outage can't lock the shopper out for an hour.
    S.processing = true; S.error = null; S.phraseIdx = 0;
    var b64 = S.pendingB64, mime = S.pendingMime, url = S.pendingUrl, file = S.pendingFile;
    render();
    clearInterval(phraseTimer);
    phraseTimer = setInterval(function () {
      S.phraseIdx++; var el = document.getElementById('dlf-pp-phrase');
      if (el) { el.style.animation = 'none'; el.offsetHeight; el.style.animation = 'dlfppPhrase 3.2s ease-in-out infinite'; el.textContent = PHRASES[S.phraseIdx % PHRASES.length]; }
    }, 3200);
    genCancelled = false; genAbort = new AbortController();
    for (var attempt = 0; attempt < 4; attempt++) {
      if (genCancelled) return;
      try {
        var r = await fetch(WORKER, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          signal: genAbort.signal, body: JSON.stringify({ image: b64, mime: mime, mode: 'full', style: styleId }) });
        var j = {}; try { j = await r.json(); } catch (e) {}
        if (j && (j.error === 'not_pet' || j.error === 'unsafe')) {
          clearInterval(phraseTimer);
          S.processing = false; S.awaitingStyle = false;
          S.pendingFile = S.pendingUrl = S.pendingB64 = null;
          S.error = j.error === 'not_pet' ? L.notPet : L.unsafe;
          genRecord(); // the model ran (and rejected) — this consumed a generation
          render(); return;
        }
        if (j && j.png_base64) {
          var res = await cleanup('data:image/png;base64,' + j.png_base64);
          clearInterval(phraseTimer);
          S.processing = false; S.pendingFile = S.pendingUrl = S.pendingB64 = null; S.error = null;
          S.photos.push({ file: file, portrait: res.url, previewFile: res.file, style: styleId });
          genRecord(); // successful generation — count it against the hourly limit
          S.sel = S.photos.length - 1; render(); return;
        }
        var msg = (j && j.error && (j.error.message || j.error)) || (j && j.detail) || ('HTTP ' + r.status);
        var transient = /internal|unavailable|overload|try again|deadline|503|500|502|429/i.test(JSON.stringify(j)) || [500, 502, 503, 429].indexOf(r.status) >= 0;
        if (transient && attempt < 3) { await sleep(3500 + attempt * 2500); continue; }
        throw new Error(msg);
      } catch (e) {
        if (genCancelled) return;
        if (attempt < 3) { await sleep(3500 + attempt * 2500); continue; }
        clearInterval(phraseTimer); S.processing = false; S.awaitingStyle = false;
        S.error = L.busy; render(); return;
      }
    }
  }

  /* ---------- in-browser cleanup: binarize + despeckle + center -> {url, file} ---------- */
  function cleanup(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var canvas;
        try { canvas = clean(img); } catch (e) { resolve({ url: src, file: null }); return; }
        var url = canvas.toDataURL('image/png');
        canvas.toBlob(function (blob) {
          resolve({ url: url, file: blob ? new File([blob], 'portrait.png', { type: 'image/png' }) : null });
        }, 'image/png');
      };
      img.onerror = function () { resolve({ url: src, file: null }); };
      img.src = src;
    });
  }
  function clean(img) {
    var W = img.naturalWidth, H = img.naturalHeight, N = W * H;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H); ctx.drawImage(img, 0, 0);
    var d = ctx.getImageData(0, 0, W, H).data, mask = new Uint8Array(N);
    for (var i = 0; i < N; i++) { var g = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2]; mask[i] = g < 200 ? 1 : 0; }
    var label = new Int32Array(N), areas = [0], st = [], cur = 0;
    for (var s = 0; s < N; s++) {
      if (!mask[s] || label[s]) continue; cur++; var a = 0; st.length = 0; st.push(s); label[s] = cur;
      while (st.length) { var p = st.pop(); a++; var x = p % W, y = (p / W) | 0;
        if (x > 0) { var n = p - 1; if (mask[n] && !label[n]) { label[n] = cur; st.push(n); } }
        if (x < W - 1) { var n2 = p + 1; if (mask[n2] && !label[n2]) { label[n2] = cur; st.push(n2); } }
        if (y > 0) { var n3 = p - W; if (mask[n3] && !label[n3]) { label[n3] = cur; st.push(n3); } }
        if (y < H - 1) { var n4 = p + W; if (mask[n4] && !label[n4]) { label[n4] = cur; st.push(n4); } } }
      areas[cur] = a;
    }
    var MIN = Math.max(40, Math.round(N * 0.00006));
    var clean2 = ctx.createImageData(W, H), cd = clean2.data, minX = W, minY = H, maxX = -1, maxY = -1;
    for (var k = 0; k < N; k++) { var keep = mask[k] && areas[label[k]] >= MIN, v = keep ? 0 : 255; cd[k * 4] = v; cd[k * 4 + 1] = v; cd[k * 4 + 2] = v; cd[k * 4 + 3] = 255;
      if (keep) { var xx = k % W, yy = (k / W) | 0; if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy; } }
    var OUT = 1000;
    if (maxX < 0) { var o0 = document.createElement('canvas'); o0.width = o0.height = OUT; var g0 = o0.getContext('2d'); g0.fillStyle = '#fff'; g0.fillRect(0, 0, OUT, OUT); return o0; }
    var cc = document.createElement('canvas'); cc.width = W; cc.height = H; cc.getContext('2d').putImageData(clean2, 0, 0);
    var cw = maxX - minX + 1, ch = maxY - minY + 1, inner = Math.round(OUT * 0.78), sc = Math.min(inner / cw, inner / ch);
    var dw = Math.round(cw * sc), dh = Math.round(ch * sc);
    var o = document.createElement('canvas'); o.width = OUT; o.height = OUT; var g = o.getContext('2d');
    g.fillStyle = '#fff'; g.fillRect(0, 0, OUT, OUT); g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    g.drawImage(cc, minX, minY, cw, ch, (OUT - dw) / 2, (OUT - dh) / 2, dw, dh);
    return o;
  }

  /* ---------- render ---------- */
  function portrait(url, px) { return '<div class="dlf-pp__portrait" style="width:' + px + 'px;height:' + px + 'px;background-image:' + (url ? 'url(' + url + ')' : 'none') + '"></div>'; }
  function errHTML() { if (!(S.error && !S.processing)) return ''; var retry = /🌱|🐾/.test(S.error) ? '' : ' <a data-act="retry">' + L.tryAgain + '</a>'; return '<div class="dlf-pp__err">' + S.error + retry + '</div>'; }

  function moduleHTML() {
    var sel = S.photos[S.sel] || {};
    if (S.uploading) return box('<div class="dlf-pp__bob" style="background-image:url(' + S.pendingUrl + ')"></div><div class="dlf-pp__t">' + L.uploading + '</div><div class="dlf-pp__bar"><i></i></div>');
    if (S.awaitingStyle) return box('<button class="dlf-pp__back" data-act="backStyle" aria-label="' + L.useDifferent + '">←</button><div class="dlf-pp__ct">' + L.chooseStyle + '</div><div class="dlf-pp__cs">' + L.chooseSub + '</div>' +
      '<div class="dlf-pp__tiles">' + TRACES.map(function (t) {
        var samp = CFG.samples && CFG.samples[t.id];
        var bg = samp ? ('background-image:url(' + samp + ')') : ('background-image:url(' + S.pendingUrl + ');filter:' + t.filter);
        return '<div class="dlf-pp__tile" data-trace="' + t.id + '"><div class="dlf-pp__ph" style="' + bg + '"></div><div class="dlf-pp__nm">' + t.label + '</div></div>';
      }).join('') + '</div>' +
      errHTML());
    var styleTail = ES ? '' : ' ' + L.styleWord;
    if (S.processing) return box('<div class="dlf-pp__spin"></div><div class="dlf-pp__revhead">' + L.vectorizing + ' | ' + traceLabel(S.trace).toUpperCase() + styleTail + '</div>' +
      '<div class="dlf-pp__phrase" id="dlf-pp-phrase">' + PHRASES[0] + '</div><div class="dlf-pp__sub">' + L.secs + '</div>' +
      '<button class="dlf-pp__link" data-act="cancel">' + L.cancel + '</button>');
    if (confirmed()) return '<div class="dlf-pp__conf">' + portrait(sel.portrait, 44) + '<div class="dlf-pp__conftxt">' + L.confirmed + '</div><div class="dlf-pp__lk"><a data-act="view">' + L.view + '</a><a data-act="change">' + L.change + '</a></div></div>';
    if (S.photos.length) return box('<div class="dlf-pp__revhead">' + L.preview + ' | ' + traceLabel(S.trace).toUpperCase() + styleTail + '</div><div style="margin:16px auto 0;width:150px">' + portrait(sel.portrait, 150) + '</div>' +
      '<div class="dlf-pp__div"><i></i><span>' + L.compare + '</span><i></i></div>' +
      '<div class="dlf-pp__compare">' + S.photos.map(function (ph, i) { return '<div class="dlf-pp__cthumb' + (i === S.sel ? ' is-on' : '') + '" data-sel="' + i + '">' + portrait(ph.portrait, 62) + '<button class="dlf-pp__cdel" data-del="' + i + '" title="' + L.remove + '">×</button></div>'; }).join('') +
        '<label class="dlf-pp__cadd">+<input type="file" accept="image/*" data-pp-add></label></div>' +
      '<button class="dlf-pp__use" data-act="use">' + L.useThis + '</button>' + errHTML() + limitNote());
    return '<label class="dlf-pp__drop"><input type="file" accept="image/*" data-pp-upl><div class="dlf-pp__droprow"><span class="dlf-pp__ic">↑</span><span class="dlf-pp__dropt">' + L.upload + '</span></div></label>' + errHTML() + limitNote();
  }
  function box(inner) { return '<div class="dlf-pp__box">' + inner + '</div>'; }

  function render() {
    if (!root) return;
    root.innerHTML = '<div class="dlf-pp__label">' + (ES ? L.heading : (CFG.heading || L.heading)) + '</div>' + moduleHTML();
    root.querySelectorAll('[data-pp-upl]').forEach(function (el) { el.onchange = function (e) { onFile(e.target.files[0]); }; });
    root.querySelectorAll('[data-pp-add]').forEach(function (el) { el.onchange = function (e) { if (e.target.files[0]) onFile(e.target.files[0]); }; });
    root.querySelectorAll('[data-trace]').forEach(function (t) { t.onclick = function () { chooseTrace(t.getAttribute('data-trace')); }; });
    root.querySelectorAll('[data-sel]').forEach(function (t) { t.onclick = function () { S.sel = +t.getAttribute('data-sel'); render(); }; });
    root.querySelectorAll('[data-del]').forEach(function (b) { b.onclick = function (e) { e.stopPropagation(); delPhoto(+b.getAttribute('data-del')); }; });
    root.querySelectorAll('[data-act]').forEach(function (a) {
      a.onclick = function () {
        var act = a.getAttribute('data-act');
        if (act === 'use') { S.photos[S.sel].confirmed = true; attachSelection(); refreshGate(); render(); }
        else if (act === 'view') { openModal(); }
        else if (act === 'change') { S.photos = []; S.sel = 0; S.trace = null; S.error = null; clearSelection(); refreshGate(); render(); }
        else if (act === 'retry') { startGenerate(S.trace); }
        else if (act === 'cancel') { cancelGeneration(); }
        else if (act === 'backStyle') { backFromStyle(); }
      };
    });
    refreshGate();
  }

  /* ---------- View modal ---------- */
  function openModal() {
    var ph = S.photos[S.sel]; if (!ph) return;
    var prevFocus = document.activeElement;
    var m = document.createElement('div'); m.className = 'dlf-pp__modal';
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', L.modalEye); m.tabIndex = -1;
    m.innerHTML = '<div class="dlf-pp__meye">' + L.modalEye + '</div><div class="dlf-pp__mimg" style="background-image:url(' + ph.portrait + ')"></div>' +
      '<div class="dlf-pp__mcap">' + L.modalCap + '</div><button class="dlf-pp__mclose">' + L.close + '</button>';
    function close() { document.removeEventListener('keydown', onKey); m.remove(); try { prevFocus && prevFocus.focus(); } catch (e) {} }
    function onKey(e) { if (e.key === 'Escape') close(); }
    m.addEventListener('click', function (e) { if (e.target === m || e.target.className === 'dlf-pp__mclose') close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(m);
    try { m.focus(); } catch (e) {}
  }

  /* ---------- pet-only DOM overrides (idempotent; re-run each tick) ----------
     The trust <p> lives inside a late-upgrading <rte-formatter> web component, so it may
     not exist on first mount. These are safe to re-run: once the trust block is trimmed,
     ppDrop no longer matches it, so it is skipped thereafter. Scoped: this JS only loads
     on products tagged 'pet-pendant'. Bilingual (EN default + es-mx). */
  function applyPetOverrides() {
    var ppShip = /insured shipping|env[ií]o asegurado/i;
    var ppDrop = /GIA|resizing|exchange|store credit|ajuste de talla|cambio|saldo a favor/i;
    document.querySelectorAll('p').forEach(function (p) {
      if (ppShip.test(p.innerHTML) && ppDrop.test(p.innerHTML)) {
        var parts = p.innerHTML.split(/<br\s*\/?>/i).filter(function (s) { return s.trim() && !ppDrop.test(s); });
        parts.push(ES ? '✓ Personalizado y hecho a pedido — venta final' : '✓ Personalized &amp; made to order — final sale');
        p.innerHTML = parts.join('<br>');
      }
    });
    ['.dlf-appt', '.dlf-edu'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) { (el.closest('[id^="shopify-section"]') || el).style.display = 'none'; }
    });
    ['sizing', 'diamonds', 'talla', 'tallas', 'diamantes'].forEach(function (name) {
      [].forEach.call(document.querySelectorAll('summary, [class*="accordion"] h2, [class*="accordion"] h3, [class*="accordion"] h4, [class*="accordion"] [class*="heading"]'), function (h) {
        var t = h.textContent.trim().toLowerCase();
        if (t === name || t.indexOf(name) === 0 && t.length < name.length + 4) {
          var row = h.closest('details, [class*="accordion-row"], [class*="accordion__item"], [class*="accordion__row"], li') || h.parentElement;
          if (row) row.style.display = 'none';
        }
      });
    });
  }

  /* ---------- mount ---------- */
  function mount() {
    if (root && document.body.contains(root)) return true;
    var f = form(); if (!f) return false;
    root = document.createElement('div'); root.className = 'dlf-pp';
    var btn = mainBtn();
    var anchor = btn && (btn.closest('buy-buttons-component, .buy-buttons, [class*="buy-buttons"], .product-form__buttons') || btn.closest('form'));
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor);
    else f.insertBefore(root, f.firstChild);
    render();

    applyPetOverrides();

    // keep gate honest if the theme re-enables the button
    if (btn && !btn.__dlfPpObs) {
      var obs = new MutationObserver(function () { if (REQUIRED && !confirmed() && !btn.disabled) { btn.disabled = true; btn.setAttribute('data-pet-required', ''); } });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      btn.__dlfPpObs = obs;
    }
    var sticky = document.querySelector('.sticky-add-to-cart__button');
    if (sticky && !sticky.__dlfPpGuard) {
      sticky.addEventListener('click', function (e) { if (REQUIRED && !confirmed()) { e.preventDefault(); e.stopImmediatePropagation(); root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }, true);
      sticky.__dlfPpGuard = true;
    }
    return true;
  }

  // First pass synchronously (the script loads after the product markup) so the pet UI is
  // in place before the first paint; the interval keeps re-ensuring while the page settles.
  mount(); applyPetOverrides();
  var tries = 0;
  var iv = setInterval(function () { mount(); applyPetOverrides(); if (++tries > 40) clearInterval(iv); }, 250);
  // one more pass after the page settles, in case the rte-formatter upgrades very late
  window.addEventListener('load', applyPetOverrides);
  document.addEventListener('shopify:section:load', applyPetOverrides);
})();
